import FrameworkList from "../../../../src/content/blog/creating-a-component-in-three-frameworks/framework-list/index.js";
import React from 'react';
export default {
  FrameworkList,
  React
};